import React, { useState } from "react";
import Preloader from "../../../components/Preloader/Preloader";
import { Col, Row, Card, Form } from 'react-bootstrap';
import { useSnackbar } from 'notistack';
import Resizer from "react-image-file-resizer";

export default function AddSlider(props) {
    const { setNewFileName, setImageFile, profileImage }=props;
    const inputRef = React.useRef();
    const [loaded, setLoaded] = useState(true);
       const { enqueueSnackbar } = useSnackbar();
   
    /*const handleFileSelection = (event)=>{
      setLoaded(false);
        event.preventDefault();
        if (event.target.files && event.target.files.length > 0) {
          setImageFile(event.target.files[0]);
          var tprofile = document.getElementById("profile");
          tprofile.src=URL.createObjectURL(event.target.files[0]);
      }
      setLoaded(true);
    }*/

      const handleFileSelection = async (event) => {
     event.preventDefault();
     const files = event.target.files;
     if (files && files.length > 0 && files.length <= 10) {
       // Only process up to 10 files
       // (You may want to loop and process all files, here only the first is resized)
      // console.log("Original File Size:", files);
       try {
        const images=[];
        var i=0;
        while( i < files.length){
        //  console.log("Processing file:", files[i]);
         await Resizer.imageFileResizer(
           files[i],
           1500,
           1500,
           "JPEG",
           100,
           0,
           (uri) => {
            images.push(uri);
             //setImageFile(uri);
           },
           "blob",
           400,
           400
         );
         i++;
        }
        //console.log("Resized files:", images);
         setImageFile(images);
       } catch (err) {
         console.log(err);
       }
     } else if (files.length > 10) {
       enqueueSnackbar("Maximum 10 files can be attached!", { variant: 'warning' });
     }
   }

  return (
    <div>
       <Preloader show={loaded ? false : true} />
      <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">Slider information</h5>
        <Form>
          <Row>
            <Col md={6} className="mb-3">
             {/*} <Form.Group id="firstName">
                <Form.Label>Slider Name</Form.Label>
                <Form.Control required type="text" placeholder="Enter Slider name"  onChange={(event)=>{setNewFileName(event.target.value)}}/>
              </Form.Group>*/}
            </Col>
          </Row>
          <Row>
          <div style={{textAlign:"center"}}> 
         {/*} <img id="profile" src={profileImage} 
         //   onError={handleImageError}
            alt="Project Photo" style={{width:"12rem", height:"12rem"}} />*/}
            <input
          type="file"
          accept="image/*"
          ref={inputRef}
          multiple
          onChange={handleFileSelection}
         // style={{ display: "none" }}
        />
        </div>
          </Row>
          
        </Form>
      </Card.Body>
    </Card>
    </div>
  )
}
